import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Modal, { ModalContent } from 'components/Modal';
import messages from './messages';
import {
  OutputInfoFormField,
  DisabledLabel,
  DisabledText,
  DoneButton,
} from './styles';

const OutputInfoClassOnDemandModal = ({
  visible,
  onDismiss,
  outputInfo,
}) => {
  const { productId, title, description, discipline, estimatedTime, previewUrl } = outputInfo;
  
  /**
   * @description handles modal dismiss
   */
  const handleDismiss = () => {
    onDismiss();
  };

  /**
   * @desc disabled text renderer.
   * @param {string} label :  label for value
   * @param {string} value :  readonly value
   */
  const DisabledWrapper = ({ label, value }) => (
    <>
      <DisabledLabel>{label}</DisabledLabel>
      <DisabledText>{value}</DisabledText>
    </>
  );

  return (
    <Modal visible={visible} onDismiss={handleDismiss} title={intl.formatMessage(messages.outputInfo)}>
      <ModalContent>
        <OutputInfoFormField>
          <DisabledWrapper
            label={intl.formatMessage(messages.productId)}
            value={productId}
          />
        </OutputInfoFormField>
        <OutputInfoFormField>
          <DisabledWrapper
            label={intl.formatMessage(messages.title)}
            value={title}
          />
        </OutputInfoFormField>
        <OutputInfoFormField>
          <DisabledWrapper
            label={intl.formatMessage(messages.description)}
            value={description}
          />
        </OutputInfoFormField>
        <OutputInfoFormField>
          <DisabledWrapper
            label={intl.formatMessage(messages.discipline)}
            value={discipline}
          />
        </OutputInfoFormField>
        <OutputInfoFormField>
          <DisabledWrapper
            label={intl.formatMessage(messages.estimatedTime)}
            value={estimatedTime}
          />
        </OutputInfoFormField>
        <OutputInfoFormField>
          <DisabledWrapper
            label={intl.formatMessage(messages.previewUrl)}
            value={previewUrl}
          />
        </OutputInfoFormField>
        <DoneButton>
          <Button primary onClick={handleDismiss}>{intl.formatMessage(messages.outputInfoDoneButton)}</Button>
        </DoneButton>
      </ModalContent>
    </Modal >);
};

OutputInfoClassOnDemandModal.propTypes = {
  onDismiss: PropTypes.func,
  visible: PropTypes.bool,
  outputInfo: PropTypes.object,
};

export default withTheme(OutputInfoClassOnDemandModal);
